// URL do stream de download usada pelo viewer 3D (single e federado).
//
// `REACT_APP_BASE_DOWNLOAD_URL` vem com barra no fim no .env, e concatenar
// `/api/...` direto gerava `//api/Download/stream` — o path duplicado faz o
// servidor redirecionar, e o redirect quebra o fetch cross-origin do motor.
export const buildFileDownloadUrl = (params: {
  constructionSiteId: number | string;
  api: number | string;
  fileApiId: string;
}): string => {
  const base = (process.env.REACT_APP_BASE_DOWNLOAD_URL || '').replace(/\/+$/, '');
  return `${base}/api/Download/stream`
    + `?constructionSiteId=${params.constructionSiteId}`
    + `&api=${params.api}`
    + `&itemsIds=${params.fileApiId}`
    + '&isViewer=true';
};
